<template>
  <section>
    <LayoutAccount>
      <template #title>
         <h5 v-if="getAppConfigReady && loginSubtitle" v-html="loginSubtitle" class="mb-3 intro-pre-title"></h5>
        {{ $t('pages.signup.headline_title_line1') }} {{ $t('pages.signup.headline_title_line2') }}
      </template>

      <template #subtitle>
        <span>{{ $t('pages.signup.headline_txt') }} <router-link :to="{ name: 'login' }" exact class="text-primary">{{ $t('forms.signup_form.btn_login') }}</router-link></span>
      </template>


      <template #mainContent>
        <SignupForm/>
      </template>
    </LayoutAccount>

    <template v-if="isPicaThirdLevelDomain">
      <B2BSection/>
    </template>
  </section>
</template>


<script>
import LayoutAccount from "@/components/LayoutAccount"
import SignupForm from "@/components/SignupForm"
import B2BSection from "@/components/B2BSection.vue";
import {mapGetters} from "vuex";

export default {
  components: {
    B2BSection,
    LayoutAccount,
    SignupForm
  },
  computed: {
    ...mapGetters(['isPicaThirdLevelDomain']),
    ...mapGetters('appConfig', ['getAppConfigReady', 'loginSubtitle'])
  },
}
</script>
